import React from "react";
import { getRandomCrypto } from "./randomFunctions";
import { Point } from "./types";

export function isMobileDevice(): boolean {
  const userAgent = navigator.userAgent;
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const screenHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  const isMobileDimensions = screenWidth <= 768 && screenHeight <= 1024; // Adjust the dimensions as needed

  return isMobile || isMobileDimensions;
}

export function snakeCaseToCapitalizedWords(snakeCaseStr: string): string {
  // Split the input string by underscores
  let words = snakeCaseStr.split("_");

  // Map through the words and capitalize the first letter of each word
  words = words.map((word) => {
    // Capitalize the first letter and add the rest of the word
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the words with spaces and return the result
  return words.join(" ");
}

export function formatDate(dateString?: string) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month < 10 ? "0" + month : month}/${
    day < 10 ? "0" + day : day
  }/${year}`;
};


export const generatePoints = (config: { numPoints: number, initialSpeed: number }): Point[] => {
  const points: Point[] = [];
  
  for (let i = 0; i < config.numPoints; i++) {
    points.push({
      x: getRandomCrypto(0, 100),
      y: getRandomCrypto(0, 100),
      dx: getRandomCrypto(-config.initialSpeed / 2, config.initialSpeed / 2),
      dy: getRandomCrypto(-config.initialSpeed / 2, config.initialSpeed / 2),
    });
  }
  
  return points;
};

export const generateLines = (points: Point[], color: string) => {
  const lines = [];

  for (let i = 0; i < points.length; i++) {
    const startPoint = points[i];

    for (let j = i + 1; j < points.length; j++) {
      const endPoint = points[j];
      const distance = Math.sqrt(
        Math.pow(endPoint.x - startPoint.x, 2) +
        Math.pow(endPoint.y - startPoint.y, 2)
      );

      if (distance < 30) {
        lines.push(
          React.createElement('line', {
            key: `line-${i}-${j}`,
            x1: `${startPoint.x}%`,
            y1: `${startPoint.y}%`,
            x2: `${endPoint.x}%`,
            y2: `${endPoint.y}%`,
            stroke: color,
            className: "moving-line"
          })
        );
      }
    }
  }

  return lines;
};